import { ad_zones_settings_context_value } from '../types';

export function createDefaultAdZonesSettingsContextValue(): ad_zones_settings_context_value {
    return {};
}

export default createDefaultAdZonesSettingsContextValue;
